import React from 'react';

function BoxRow(props){
    return (
		<div className="partsSearchResultComponent-boxRow">
            <div className="partsSearchResultComponent-boxTitle">{props.title}</div>
            <div className="partsSearchResultComponent-boxDesc">{props.desc}</div>
        </div>
    );
}

export default BoxRow;